import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// Module-level cache so siblings don't refetch
let _cache = null;
let _subscribers = [];

const notify = (data) => {
  _cache = data;
  _subscribers.forEach(fn => fn(data));
};

/**
 * Returns { categories, refresh } where categories is sorted [{key, label, shipping_cost, sort_order, is_system}].
 * First component to mount triggers the fetch; subsequent mounts share the cache.
 */
export function useCategories() {
  const [categories, setCategories] = useState(_cache || []);

  useEffect(() => {
    const handler = (data) => setCategories(data);
    _subscribers.push(handler);
    if (_cache === null) {
      axios.get(`${API}/api/categories`)
        .then(res => notify(res.data))
        .catch(err => { console.error("Failed to load categories", err); notify([]); });
    }
    return () => { _subscribers = _subscribers.filter(fn => fn !== handler); };
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/api/categories`);
      notify(data);
    } catch (e) {
      console.error("Failed to refresh categories", e);
    }
  }, []);

  return { categories, refresh };
}

export function invalidateCategoriesCache() {
  _cache = null;
  axios.get(`${API}/api/categories`).then(res => notify(res.data)).catch(() => {});
}
